import e, { useState as r, useCallback as d, useEffect as h } from "react";
import t from "./index261.mjs";
import w from "classnames";
import { v4 as p } from "uuid";
const N = ({
  amenities: o,
  isExpanded: m
}) => {
  const [c, a] = r([]), [s, u] = r(!0), i = window.innerWidth < 376 ? 5 : m ? 15 : 10, f = o.length > i, n = d(() => {
    const l = o.slice(0, i);
    a(l);
  }, [o, i]);
  h(() => {
    n();
  }, [n]);
  const b = () => {
    s ? a(o) : n(), u(!s);
  };
  return /* @__PURE__ */ e.createElement("div", { className: t.amenities }, /* @__PURE__ */ e.createElement("div", { className: t["amenities-list"] }, c.map((l) => /* @__PURE__ */ e.createElement(
    "div",
    {
      key: p(),
      className: w(
        {
          [t.expanded]: m
        },
        [t.amenity]
      )
    },
    /* @__PURE__ */ e.createElement("span", null, l)
  ))), f ? /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      "data-testid": "show-more-button",
      className: t["show-more-button"],
      onClick: b
    },
    I18n.t(
      `booking_engine.information.show_${s ? "more" : "less"}`
    )
  ) : null);
};
export {
  N as RoomAmenities
};
